// import React from "react";
// import {
//   Box,
//   Typography,
//   Avatar,
//   Chip,
//   Divider,
//   Paper,
//   Button,
//   Stack,
// } from "@mui/material";
// import {
//   FaBolt,           // ⚡ same
//   FaArrowUp,        // closest to FaArrowUpRight (↗)
//   FaFire,           // 🔥 same
//   FaChevronDown     // ⌄ same
// } from "react-icons/fa";
// import HeaderSection from "./HeaderSection";

// const players = [
//   {
//     name: "Max Meyer",
//     team: "SP - MIA",
//     match: "COL @ MIA Jun 3rd 4:10 AM",
//     avatar:
//       "https://img.mlbstatic.com/mlb-photos/image/upload/q_auto:eco,dpr_2.0/v1/people/669370/headshot/current",
//     options: [
//       { label: "5.5 SO (K)", value: "1.54x", hot: true },
//       { label: "4.5 SO (K)", value: "1.16x" },
//       { label: "6.5 SO (K)", value: "1.91x" },
//       { label: "7.5 SO (K)", value: "2.8x" },
//     ],
//   },
//   {
//     name: "Riley Greene",
//     team: "OF - DET",
//     match: "DET @ NYY Jun 3rd 7:05 PM",
//     avatar:
//       "https://img.mlbstatic.com/mlb-photos/image/upload/q_auto:eco,dpr_2.0/v1/people/666450/headshot/current",
//     options: [
//       { label: "2.5 HR", value: "2.10x", hot: true },
//       { label: "1.5 HR", value: "1.50x" },
//       { label: "3.5 HR", value: "2.75x" },
//       { label: "4.5 HR", value: "4.0x" },
//     ],
//   },
// ];

// const PlayerCard = ({ player }) => (
//   <Paper
//     elevation={4}
//     sx={{
//       borderRadius: 4,
//       p: 3,
//       position: "relative",
//       overflow: "visible",
//       mb: 3,
//     }}
//   >
//     <Chip
//       label={
//         <Typography fontWeight="bold" fontSize={14}>
//           Payout Boost Special*
//         </Typography>
//       }
//       sx={{
//         backgroundColor: "#FFD500",
//         color: "black",
//         fontWeight: "bold",
//         px: 3,
//         py: 1,
//         position: "absolute",
//         top: 12,
//         left: "50%",
//         transform: "translateX(-50%)",
//         borderRadius: 3,
//         boxShadow: "0 2px 6px rgba(255, 213, 0, 0.6)",
//         zIndex: 10,
//       }}
//     />
//     <Box position="absolute" top={16} right={16} color="goldenrod" zIndex={10}>
//       <FaBolt size={22} />
//     </Box>

//     <Box display="flex" alignItems="center" gap={2} mt={4} mb={3}>
//       <Avatar src={player.avatar} sx={{ width: 56, height: 56 }} />
//       <Box>
//         <Typography fontWeight="bold" fontSize={18}>{player.name}</Typography>
//         <Typography fontSize={14} color="text.secondary">
//           {player.team}
//         </Typography>
//         <Typography fontSize={13} color="text.secondary">
//           {player.match}
//         </Typography>
//       </Box>
//       <Box ml="auto" color="gray">
//         <FaArrowUp size={20} />
//       </Box>
//     </Box>

//     <Divider sx={{ my: 1 }} />

//     <Box display="flex" justifyContent="space-between" mb={2} px={1}>
//       <Button
//         variant="contained"
//         sx={{
//           bgcolor: "#fff6e0",
//           color: "#000",
//           borderRadius: 20,
//           boxShadow: "0 2px 6px rgba(255, 213, 0, 0.5)",
//           textTransform: "none",
//           fontWeight: "bold",
//           display: "flex",
//           alignItems: "center",
//           gap: 0.5,
//           px: 2,
//           py: 0.8,
//           minWidth: 100,
//         }}
//         startIcon={<FaBolt style={{ color: "gold", verticalAlign: "middle" }} />}
//       >
//         Less
//       </Button>
//       <Button
//         variant="contained"
//         sx={{
//           bgcolor: "#fff6e0",
//           color: "#000",
//           borderRadius: 20,
//           boxShadow: "0 2px 6px rgba(255, 213, 0, 0.5)",
//           textTransform: "none",
//           fontWeight: "bold",
//           px: 2,
//           py: 0.8,
//           minWidth: 100,
//         }}
//       >
//         More
//       </Button>
//     </Box>

//     {player.options.map((opt, i) => (
//       <Box
//         key={i}
//         display="flex"
//         justifyContent="space-between"
//         alignItems="center"
//         p={1}
//         my={1}
//         borderRadius={3}
//         sx={{
//           backgroundColor: i === 0 ? "#fff6e0" : "#f2f2f2",
//           boxShadow: i === 0 ? "0 0 0 2px #FFD500" : undefined,
//         }}
//       >
//         <Box width={40}></Box>
//         <Typography fontWeight={500}>{opt.label}</Typography>
//         <Box
//           display="flex"
//           alignItems="center"
//           gap={0.5}
//           fontWeight="bold"
//           px={2}
//           py={0.5}
//           borderRadius={20}
//           bgcolor="#fff"
//         >
//           {opt.hot && <FaFire size={12} color="#FF5722" />}
//           <Typography>{opt.value}</Typography>
//         </Box>
//       </Box>
//     ))}

//     <Box mt={3} textAlign="center">
//       <Button
//         variant="contained"
//         size="small"
//         sx={{
//           backgroundColor: "#FFD500",
//           color: "black",
//           fontWeight: "bold",
//           borderRadius: 8,
//           textTransform: "none",
//           px: 4,
//           py: 1,
//           boxShadow: "0 4px 8px rgba(255, 213, 0, 0.6)",
//         }}
//         startIcon={<FaChevronDown />}
//       >
//         Show more
//       </Button>
//     </Box>
//   </Paper>
// );

// const HomePage = () => {
//   return (
//     <>
//       <HeaderSection />
//       <Box p={3} maxWidth={480} mx="auto">
//         <Stack spacing={3}>
//           {players.map((player, idx) => (
//             <PlayerCard key={idx} player={player} />
//           ))}
//         </Stack>
//       </Box>
//     </>
//   );
// };

// export default HomePage;

import React, { useState } from "react";
import {
  Box,
  Typography,
  Avatar,
  Chip,
  Divider,
  Paper,
  Button,
  Stack,
  Grid,
  IconButton,
} from "@mui/material";
import {
  FaBolt,
  FaArrowUp,
  FaFire,
  FaChevronDown,
  FaLightbulb,
  FaCheckCircle,
  FaTimes,
} from "react-icons/fa";
import HeaderSection from "./HeaderSection";
import RightSide from "./RightSide";
import LeftSide from "./LeftSide";

// sample players data
const players = [
  {
    id: 1,
    name: "Max Meyer",
    team: "SP - MIA",
    match: "COL @ MIA Jun 3rd 4:10 AM",
    avatar:
      "https://img.mlbstatic.com/mlb-photos/image/upload/q_auto:eco,dpr_2.0/v1/people/669370/headshot/current",
    stat: "SO (K)",
    options: [
      { side: "More", label: "5.5 SO (K)", value: "1.54x", hot: true },
      { side: "More", label: "4.5 SO (K)", value: "1.16x" },
      { side: "More", label: "6.5 SO (K)", value: "1.91x" },
      { side: "More", label: "7.5 SO (K)", value: "2.8x" },
    ],
  },
  {
    id: 2,
    name: "Riley Greene",
    team: "OF - DET",
    match: "DET @ CWS Jun 3rd 5:10 AM",
    avatar:
      "https://img.mlbstatic.com/mlb-photos/image/upload/q_auto:eco,dpr_2.0/v1/people/666450/headshot/current",
    stat: "Hits",
    options: [
      { side: "Less", label: "1.5 Hits", value: "1.3x", hot: false },
      { side: "More", label: "0.5 Hits", value: "1.36x", hot: true },
      { side: "More", label: "1.5 Hits", value: "2.64x" },
      { side: "More", label: "2.5 Hits", value: "6.74x" },
    ],
  },
  {
    id: 3,
    name: "Jung Hoo Lee",
    team: "CF - SF",
    match: "SF @ PHI Jun 3rd 7:45 AM",
    avatar:
      "https://img.mlbstatic.com/mlb-photos/image/upload/q_auto:eco,dpr_2.0/v1/people/808982/headshot/current",
    stat: "Hits",
    options: [
      { side: "Less", label: "1.5 Hits", value: "1.5x", hot: false },
      { side: "More", label: "0.5 Hits", value: "1.25x" },
      { side: "More", label: "1.5 Hits", value: "2.1x" },
    ],
  },
];

const HomePage = () => {
  const [selectedPicks, setSelectedPicks] = useState([]);

  const handleSelectOption = (player, option) => {
    const existing = selectedPicks.find((p) => p.player.id === player.id);
    const newPick = { player, option };

    if (existing) {
      // Replace existing pick
      setSelectedPicks((prev) =>
        prev.map((p) => (p.player.id === player.id ? newPick : p))
      );
    } else {
      // Add new pick
      setSelectedPicks((prev) => [...prev, newPick]);
    }
  };

  const handleRemovePick = (playerId) => {
    setSelectedPicks((prev) => prev.filter((p) => p.player.id !== playerId));
  };

  const isOptionSelected = (playerId, option) => {
    const pick = selectedPicks.find((p) => p.player.id === playerId);
    return (
      pick &&
      pick.option.label === option.label &&
      pick.option.side === option.side
    );
  };

  return (
    <>
      <HeaderSection />
      <Grid container spacing={3} sx={{ px: 3, py: 2 }}>
        {/* Left Side - player list */}
        <LeftSide
          selectedPicks={selectedPicks}
          handleSelectOption={handleSelectOption}
        />

        {/* Right Side - Pick Summary */}
        {/* <Grid item xs={12} md={5}>
          <Stack spacing={2}>
           
            <Box
              bgcolor="#f5f5f5"
              borderRadius="20px"
              p={2}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Chip
                label="+ 5% Boost 🚀"
                sx={{
                  backgroundColor: "#222",
                  color: "#fff",
                  borderRadius: "999px",
                }}
              />
              <Typography fontWeight="bold" fontSize={18}>
                2.00x
              </Typography>
            </Box>

            
            {selectedPicks.map((pick, index) => (
              <Paper
                key={index}
                sx={{
                  backgroundColor: "#FFD500",
                  borderRadius: "20px",
                  p: 2,
                  position: "relative",
                }}
              >
                <Typography fontSize={12} mb={1}>
                  *1 entry up to $250
                </Typography>
                <Chip
                  label={
                    <Typography fontWeight="bold" fontSize={12}>
                      Payout Boost Special* &nbsp; 09:04:28
                    </Typography>
                  }
                  sx={{
                    backgroundColor: "#222",
                    color: "#fff",
                    px: 2,
                    py: 0.5,
                    borderRadius: "999px",
                  }}
                />
                <IconButton
                  size="small"
                  sx={{
                    position: "absolute",
                    top: 12,
                    right: 12,
                    color: "gray",
                  }}
                  onClick={() => handleRemovePick(pick.player.id)}
                >
                  <FaTimes />
                </IconButton>

                <Box display="flex" alignItems="center" mt={2} gap={2}>
                  <Avatar
                    src={pick.player.avatar}
                    sx={{ width: 56, height: 56 }}
                  />
                  <Box>
                    <Typography fontWeight="bold">
                      {pick.player.team.split(" - ")[1]} - {pick.player.name}
                    </Typography>
                    <Typography fontSize={12} color="text.secondary">
                      {pick.player.match}
                    </Typography>
                  </Box>
                </Box>

                <Box display="flex" justifyContent="space-between" mt={2}>
                  <Box
                    bgcolor="#fff"
                    borderRadius="16px"
                    p={1}
                    textAlign="center"
                    flex={1}
                    mr={1}
                    fontWeight="bold"
                  >
                    <FaCheckCircle color="#00cc66" /> <br />
                    {pick.option.value} <br />
                    {pick.option.side} <br />
                    {pick.option.label}
                  </Box>
                  <Box
                    bgcolor="#fff"
                    borderRadius="16px"
                    p={1}
                    textAlign="center"
                    flex={1}
                    ml={1}
                  >
                  
                    {pick.option.value} <br />
                    {pick.option.side} <br />
                    {pick.option.label}
                  </Box>
                </Box>
              </Paper>
            ))}

           
            <Box textAlign="center" mt={3}>
              <Typography variant="h5" fontWeight="bold">
                Entry Amount
              </Typography>
              <Typography mt={1} fontSize={14}>
                (min: $1, max: $2500)
              </Typography>
            </Box>
          </Stack>
        </Grid> */}
        {/* Right Side - Pick Summary */}
        <RightSide
          selectedPicks={selectedPicks}
          handleRemovePick={handleRemovePick}
        />
      </Grid>
    </>
  );
};

export default HomePage;
